/* eslint-disable @dhl/mui/no-hardcoded-colors */
import { type LogoProps } from './types'

/**
 * PPL Logo
 *
 * Demos:
 * - [Logo](https://design-system.accept.cl1.intra.dhlparcel.io/?path=/docs/primitives-logo--docs)
 *
 *  QQ: make extra Icon for AppHeader?
 */

export const PPLLogo = ({ width, height }: LogoProps) => {
  const color = '#ffffff'
  const dhlYellow = '#FFCC00'
  const dhlRed = '#D40511'

  return (
    <svg viewBox="0 0 193 36" width={width} height={height} fill="none">
      <g clipPath="url(#clip0_4167_540)">
        <mask id="mask0_4167_540" maskUnits="userSpaceOnUse" x="0" y="-3" width="193" height="43">
          <path d="M193 -2.32275H0V39.4837H193V-2.32275Z" fill={color} />
        </mask>
        <g mask="url(#mask0_4167_540)">
          <mask id="mask1_4167_540" maskUnits="userSpaceOnUse" x="0" y="5" width="195" height="28">
            <path d="M194.391 5.80664H0V32.4313H194.391V5.80664Z" fill={color} />
          </mask>
          <g mask="url(#mask1_4167_540)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M113.355 22.8002L112.087 26.9108H88.4038L93.3885 10.7036H102.625L98.9078 22.8002H113.355Z"
              fill={color}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M45.4578 17.8736H38.7841L40.0513 13.7888H46.6693C47.8798 13.7888 49.0068 14.7109 48.6401 15.8442C48.3308 16.8977 47.4014 17.7415 45.4578 17.8736ZM49.6263 10.7051H31.7437L26.7881 26.912H36.0236L37.8261 20.9565H46.6691C51.7098 20.9565 56.3007 18.8749 57.1737 16.0281C57.9052 13.7102 55.7083 10.7051 49.6263 10.7051Z"
              fill={color}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M76.265 17.8736H69.5912L70.859 13.7888H77.5046C78.7153 13.7888 79.8135 14.7109 79.4754 15.8442C79.1379 16.8977 78.2081 17.7415 76.265 17.8736ZM80.4328 10.7051H62.5513L57.5947 26.912H66.8311L68.6622 20.9565H77.5046C82.5174 20.9565 87.1346 18.8749 88.008 16.0281C88.7128 13.7102 86.5163 10.7051 80.4328 10.7051Z"
              fill={color}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M22.0852 26.9117L23.465 22.4321H2.68198L1.30225 26.9117H22.0852Z"
              fill={color}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M25.4081 16.1065L26.281 13.2871H5.46972L4.62549 16.1065H25.4081Z"
              fill={color}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M23.8592 21.1142L25.0144 17.3984H4.23166L3.07666 21.1142H23.8592Z"
              fill={color}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M26.674 11.9968L27.0684 10.7051H6.28575L5.8916 11.9968H26.674Z"
              fill={color}
            />
            <path
              d="M116.73 16.2966C117.375 16.8967 118.27 17.2685 119.266 17.2685L119.267 17.5806C118.181 17.5802 117.202 17.1744 116.495 16.5169L116.73 16.2966ZM115.689 13.9464C115.689 14.8652 116.085 15.6962 116.73 16.2966L116.495 16.5169C115.789 15.8596 115.355 14.9507 115.355 13.9464H115.689ZM116.73 11.573C116.085 12.1764 115.689 13.0147 115.689 13.9464H115.355C115.355 12.9286 115.789 12.0126 116.495 11.3518L116.73 11.573ZM119.266 10.597C118.271 10.5975 117.375 10.9684 116.73 11.573L116.495 11.3518C117.201 10.6913 118.18 10.2856 119.266 10.2852V10.597ZM121.793 11.5726C121.145 10.9684 120.248 10.5975 119.266 10.597V10.2852C120.339 10.2856 121.318 10.6911 122.028 11.3514L121.793 11.5726ZM122.845 13.9455C122.845 13.0134 122.442 12.1764 121.793 11.5726L122.028 11.3514C122.737 12.0126 123.179 12.9277 123.179 13.9455H122.845ZM121.794 16.2959C122.442 15.6955 122.845 14.8641 122.845 13.9455H123.179C123.179 14.9498 122.737 15.8596 122.028 16.5165L121.794 16.2959ZM119.266 17.2685C120.249 17.2685 121.145 16.8967 121.794 16.2959L122.028 16.5165C121.318 17.1744 120.34 17.5802 119.267 17.5806L119.266 17.2685Z"
              fill={color}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M118.198 13.6303H119.662C120.14 13.6303 120.647 13.5253 120.872 12.9185C121.097 12.2863 120.563 12.2342 120.252 12.2342H118.676L118.198 13.6303ZM117.409 15.8443H116.79L118.198 11.7598H120.366C121.155 11.7598 121.858 11.9969 121.549 12.8665C121.351 13.4722 120.901 13.6825 120.563 13.8416C120.787 13.9468 121.014 14.0522 120.845 14.6058L120.647 15.3434C120.563 15.5806 120.563 15.6592 120.732 15.7653L120.704 15.8443H119.916C119.916 15.5806 120.112 14.9743 120.168 14.8159C120.281 14.5003 120.339 14.1049 119.578 14.1049H118.028L117.409 15.8443Z"
              fill={color}
            />
            <path d="M193.186 16.2549H141.537V26.9105H193.186V16.2549Z" fill={dhlYellow} />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M150.615 17.7734L148.97 19.8841H157.974C158.416 19.8841 158.416 20.0403 158.194 20.3155C157.974 20.6102 157.584 21.1117 157.362 21.3892C157.232 21.5443 157.029 21.8035 157.733 21.8035H161.411C161.411 21.8035 162.001 21.0609 162.502 20.4202C163.168 19.5728 162.557 17.7734 160.134 17.7734H150.615Z"
              fill={dhlRed}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M148.303 24.6048L151.612 20.4014H155.733C156.178 20.4014 156.178 20.5581 155.956 20.8338C155.733 21.1281 155.345 21.6127 155.124 21.9068C154.995 22.0625 154.791 22.3219 155.494 22.3219H161.001C160.539 22.9099 159.061 24.6048 156.38 24.6048H148.303Z"
              fill={dhlRed}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M167.289 22.3218L165.496 24.6051H160.745L162.538 22.3218H167.289Z"
              fill={dhlRed}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M177.712 17.7734H172.98L171.151 20.0913H169.044L170.855 17.7734H166.123L162.943 21.8035H174.552L177.712 17.7734Z"
              fill={dhlRed}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M141.537 23.2212H148.524L148.136 23.7051H141.537"
              fill={dhlRed}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M141.537 22.3218H149.228L148.839 22.8067H141.537"
              fill={dhlRed}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M141.537 24.1387H147.803L147.435 24.6057H141.537"
              fill={dhlRed}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M174.145 22.3218L172.333 24.6051H167.601L169.394 22.3218H174.145Z"
              fill={dhlRed}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M193.184 23.7056H186.234L186.603 23.2222H193.184"
              fill={dhlRed}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M193.185 24.605H185.513L185.902 24.1387H193.185"
              fill={dhlRed}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M187.327 22.3218H193.188V22.8067H186.939L187.327 22.3218Z"
              fill={dhlRed}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M184.276 17.7734L181.115 21.8035H176.087L179.266 17.7734H184.276Z"
              fill={dhlRed}
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M186.458 22.3218L184.647 24.6051H177.048C175.108 24.6051 174.571 23.7414 175.162 22.9794C175.329 22.7729 175.681 22.3218 175.681 22.3218H186.458Z"
              fill={dhlRed}
            />
            <path
              d="M141.605 13.3105L142.75 10.0986H143.473L144.617 13.3105H144.133L143.837 12.4784H142.37L142.074 13.3105H141.605ZM143.068 10.4977L142.5 12.1085H143.706L143.14 10.4977H143.068Z"
              fill={color}
            />
            <path
              d="M146.898 13.3695C146.674 13.3695 146.476 13.3199 146.305 13.2211C146.137 13.1221 146.004 12.9843 145.91 12.8073C145.817 12.6306 145.771 12.4238 145.771 12.1868V12.0018C145.771 11.7651 145.817 11.5583 145.91 11.3815C146.004 11.2047 146.137 11.0667 146.305 10.9677C146.476 10.869 146.674 10.8193 146.898 10.8193C147.248 10.8193 147.543 10.9395 147.783 11.1796L147.538 11.4473C147.368 11.2784 147.166 11.1941 146.93 11.1941C146.708 11.1941 146.534 11.268 146.407 11.4156C146.28 11.5632 146.217 11.7634 146.217 12.0166V12.1723C146.217 12.4254 146.28 12.6257 146.407 12.7733C146.534 12.921 146.708 12.9947 146.93 12.9947C147.183 12.9947 147.394 12.9104 147.564 12.7416L147.809 13.0092C147.573 13.2494 147.269 13.3695 146.898 13.3695Z"
              fill={color}
            />
            <path
              d="M149.231 13.3695C148.988 13.3695 148.78 13.3199 148.607 13.2211C148.433 13.1221 148.301 12.9843 148.208 12.8073C148.117 12.6306 148.071 12.4238 148.071 12.1868V12.0018C148.071 11.7651 148.117 11.5583 148.208 11.3815C148.301 11.2047 148.433 11.0667 148.607 10.9677C148.78 10.869 148.988 10.8193 149.231 10.8193C149.473 10.8193 149.681 10.869 149.854 10.9677C150.028 11.0667 150.16 11.2047 150.253 11.3815C150.344 11.5583 150.39 11.7651 150.39 12.0018V12.1868C150.39 12.4238 150.344 12.6306 150.253 12.8073C150.16 12.9843 150.028 13.1221 149.854 13.2211C149.681 13.3199 149.473 13.3695 149.231 13.3695ZM149.231 12.9996C149.452 12.9996 149.627 12.9273 149.755 12.783C149.884 12.6388 149.948 12.4351 149.948 12.1723V12.0166C149.948 11.7536 149.884 11.5501 149.755 11.4058C149.627 11.2614 149.452 11.1892 149.231 11.1892C149.009 11.1892 148.833 11.2614 148.705 11.4058C148.576 11.5501 148.512 11.7538 148.512 12.0166V12.1723C148.512 12.4351 148.576 12.6388 148.705 12.783C148.833 12.9273 149.009 12.9996 149.231 12.9996Z"
              fill={color}
            />
            <path
              d="M150.93 13.3115V10.8781H151.341V11.3454C151.417 11.1995 151.525 11.077 151.663 10.978C151.802 10.8791 151.977 10.8296 152.188 10.8296C152.376 10.8296 152.536 10.8742 152.669 10.9635C152.802 11.0526 152.898 11.1849 152.952 11.3601C153.032 11.2141 153.141 11.0892 153.28 10.9853C153.419 10.8816 153.6 10.8296 153.821 10.8296C154.078 10.8296 154.281 10.9091 154.431 11.068C154.582 11.227 154.658 11.464 154.658 11.7785V13.3115H154.216V11.832C154.216 11.6212 154.17 11.463 154.078 11.3576C153.987 11.2523 153.855 11.1995 153.68 11.1995C153.518 11.1995 153.38 11.2417 153.27 11.3259C153.159 11.4103 153.074 11.506 153.015 11.6131V13.3115H152.573V11.832C152.573 11.6212 152.528 11.463 152.435 11.3576C152.343 11.2523 152.211 11.1995 152.038 11.1995C151.874 11.1995 151.737 11.2417 151.627 11.3259C151.515 11.4103 151.431 11.506 151.372 11.6131V13.3115H150.93Z"
              fill={color}
            />
            <path
              d="M155.317 14.236V10.8781H155.728V11.3454C155.818 11.18 155.937 11.0526 156.084 10.9635C156.232 10.8742 156.399 10.8296 156.586 10.8296C156.783 10.8296 156.957 10.8781 157.106 10.9755C157.255 11.0729 157.371 11.2092 157.452 11.3844C157.533 11.5595 157.574 11.7656 157.574 12.0025V12.1871C157.574 12.4242 157.533 12.6302 157.452 12.8053C157.371 12.9806 157.255 13.1168 157.106 13.2141C156.957 13.3115 156.783 13.3601 156.586 13.3601C156.41 13.3601 156.25 13.3203 156.108 13.2409C155.965 13.1614 155.85 13.0472 155.76 12.8978V14.236H155.317ZM156.44 11.1995C156.299 11.1995 156.168 11.2359 156.048 11.3088C155.928 11.382 155.832 11.4833 155.76 11.6131V12.5767C155.832 12.7065 155.928 12.8078 156.048 12.8808C156.168 12.9537 156.299 12.9903 156.44 12.9903C156.655 12.9903 156.825 12.9181 156.948 12.7737C157.071 12.6294 157.133 12.4291 157.133 12.1727V12.017C157.133 11.7608 157.071 11.5604 156.948 11.416C156.825 11.2717 156.655 11.1995 156.44 11.1995Z"
              fill={color}
            />
            <path
              d="M158.647 13.3597C158.414 13.3597 158.225 13.294 158.079 13.1625C157.935 13.0312 157.861 12.86 157.861 12.6491C157.861 12.4124 157.954 12.225 158.137 12.087C158.321 11.9492 158.57 11.8804 158.886 11.8804H159.474V11.8024C159.474 11.3905 159.269 11.1843 158.86 11.1843C158.742 11.1843 158.626 11.2047 158.512 11.2451C158.397 11.2858 158.298 11.3433 158.216 11.418L157.986 11.1406C158.225 10.9265 158.526 10.8193 158.891 10.8193C159.561 10.8193 159.895 11.1472 159.895 11.8024V12.7465C159.895 12.9185 159.968 13.0044 160.113 13.0044C160.127 13.0044 160.142 13.0037 160.157 13.0021C160.173 13.0004 160.193 12.998 160.217 12.9947V13.345C160.158 13.3548 160.087 13.3597 160.004 13.3597C159.692 13.3597 159.522 13.2105 159.494 12.9121C159.401 13.0547 159.282 13.165 159.136 13.243C158.99 13.3207 158.827 13.3597 158.647 13.3597ZM158.777 13.0044C159.075 13.0044 159.308 12.8682 159.474 12.5957V12.2015H158.928C158.734 12.2015 158.581 12.2396 158.471 12.3158C158.36 12.3921 158.303 12.4966 158.303 12.6298C158.303 12.7433 158.346 12.8341 158.431 12.9022C158.516 12.9704 158.631 13.0044 158.777 13.0044Z"
              fill={color}
            />
            <path
              d="M160.606 13.3115V10.8781H161.018V11.3454C161.097 11.2027 161.206 11.0811 161.345 10.9804C161.483 10.88 161.661 10.8296 161.876 10.8296C162.136 10.8296 162.343 10.9091 162.497 11.068C162.652 11.227 162.728 11.464 162.728 11.7785V13.3115H162.287V11.832C162.287 11.6212 162.239 11.463 162.141 11.3576C162.043 11.252 161.907 11.1995 161.73 11.1995C161.564 11.1995 161.424 11.2417 161.311 11.3259C161.199 11.4103 161.111 11.506 161.049 11.6129V13.3115H160.606Z"
              fill={color}
            />
            <path
              d="M163.729 14.2357L164.083 13.3111H163.89L163.005 10.8779H163.484L164.196 12.9414H164.259L164.977 10.8779H165.439L164.181 14.2357H163.729Z"
              fill={color}
            />
            <path
              d="M167.747 13.3695C167.505 13.3695 167.297 13.3199 167.124 13.2211C166.95 13.1221 166.818 12.9843 166.726 12.8073C166.635 12.6306 166.588 12.4238 166.588 12.1868V12.0018C166.588 11.7651 166.635 11.5583 166.726 11.3815C166.818 11.2047 166.95 11.0667 167.124 10.9677C167.297 10.869 167.505 10.8193 167.747 10.8193C167.991 10.8193 168.198 10.869 168.373 10.9677C168.546 11.0667 168.678 11.2047 168.769 11.3815C168.861 11.5583 168.908 11.7651 168.908 12.0018V12.1868C168.908 12.4238 168.861 12.6306 168.769 12.8073C168.678 12.9843 168.546 13.1221 168.373 13.2211C168.198 13.3199 167.991 13.3695 167.747 13.3695ZM167.747 12.9996C167.97 12.9996 168.145 12.9273 168.274 12.783C168.401 12.6388 168.466 12.4351 168.466 12.1723V12.0166C168.466 11.7536 168.401 11.5501 168.274 11.4058C168.145 11.2614 167.97 11.1892 167.747 11.1892C167.526 11.1892 167.351 11.2614 167.223 11.4058C167.094 11.5501 167.031 11.7538 167.031 12.0166V12.1723C167.031 12.4351 167.094 12.6388 167.223 12.783C167.351 12.9273 167.526 12.9996 167.747 12.9996Z"
              fill={color}
            />
            <path
              d="M169.583 13.31V11.2273H169.142V10.8769H169.583V10.7358C169.583 10.4276 169.659 10.202 169.81 10.0594C169.96 9.91666 170.175 9.84521 170.452 9.84521C170.501 9.84521 170.544 9.84686 170.585 9.85012C170.625 9.85339 170.659 9.85828 170.691 9.86461V10.2198C170.614 10.2102 170.552 10.2053 170.503 10.2053C170.324 10.2053 170.198 10.2492 170.13 10.3365C170.059 10.4243 170.025 10.5621 170.025 10.7503V10.8769H170.696V11.2271H170.025V13.31H169.583Z"
              fill={color}
            />
            <path d="M130.913 6.98389H130.481V31.6532H130.913V6.98389Z" fill={color} />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_4167_540">
          <rect width="193" height="36" fill={color} />
        </clipPath>
      </defs>
    </svg>
  )
}
